import React from 'react';
import ConfirmationDialog from 'components/dialogs/ConfirmationDialog';
import { OverlayProps } from 'components/TaskOverlay';
import { t } from '@lingui/macro';
import { Text, VStack } from '@cardboard-ui/react';

interface UnsavedSignatureSetupDialogProps extends OverlayProps {
  onAction: () => void;
}

export const UnsavedSignatureSetupDialog = ({
  isOpen,
  onClose,
  onAction,
}: UnsavedSignatureSetupDialogProps) => {
  return (
    <ConfirmationDialog
      action={{
        name: t`Unsaved Signature Setup`,
        onAction,
      }}
      isOpen={isOpen}
      onClose={onClose}
      confirmationText={t`Exit`}
      cancelText={t`Stay and Continue`}
    >
      <VStack alignItems="flex-start" spacing={4}>
        <Text>{t`You are about to leave an unsaved Signature setup.`}</Text>
        <Text>
          {t`If you exit the setup process, all changes will be lost.`}
        </Text>
        <Text fontWeight="bold">{t`Do you want to exit?`}</Text>
      </VStack>
    </ConfirmationDialog>
  );
};
